import { render, staticRenderFns } from "./SentInfoHistory.vue?vue&type=template&id=380f4abd&"
import script from "./SentInfoHistory.vue?vue&type=script&lang=js&"
export * from "./SentInfoHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports